( function($) {
	// Mobile menu button toggle function
	$( '.mobile-menu-btn' ).on( 'click', function() {
		$( this ).toggleClass( 'active' );
	});

	// Add a overview link to each parent mobile menu item
	// $(".mex-primary-mobile-menu-container li.menu-item-has-children > a").one("click", function () {
  //       var target = $(this);
  //       var value = target.attr("href");
  //       var element = target.parent("li");
    
  //       target.removeAttr("href");
    
  //       element
  //         .children("ul")
  //         .first("li")
  //         .prepend('<li><a class="dropdown-item" href="' + value + '">Overview</a></li>');
  //   });

	/**
	 * Bootstrap disables parent links from opening their page, and instead displays its children.
	 * This is fine for mobile menus, but we want parent links to work on desktop.
	 */
	function setNavDropdownItem() {
		var windowWidth = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 );
		var navDropdownItem = $( '#main-menu-desktop' ).find( "[data-bs-toggle]" );
	
		// 768 = $screen-md, 992 = $screen-lg
		if( windowWidth >= 1200 ) {
		  navDropdownItem.attr( "data-bs-toggle", 'massage-dropdown' );
		} else {
		  navDropdownItem.attr( "data-bs-toggle", 'dropdown' );
		}
	}
	
	/**
	 * Run the function should users resize their window.
	 */
	window.addEventListener( 'resize', function() {
		setNavDropdownItem();
	}, true);

	setNavDropdownItem();

	// Check if user is on the team page template
	// if( $( ".mex-local-team-page-container" ).length ) {
		$( '.member-read-more-btn' ).on( 'click', function(e) {
			e.preventDefault();

			// Toggle between team member's bio
			if( $( this ).hasClass( 'read-less' ) ) {
				$( this ).parents('.card-body').find('.excerpt').show();
				$( this ).parents('.card-body').find('.full-bio').hide();
				$( this ).removeClass( 'read-less' );
			}
			else {
				$( this ).parents('.card-body').find('.excerpt').hide();
				$( this ).parents('.card-body').find('.full-bio').show();
				$( this ).addClass( 'read-less' );
			}
		} );
	// }



	// See More mobile button on service page
	$( '.see-more-btn' ).on( 'click', function() {
		$( '.list-card-container' ).removeClass( 'd-none' );
		$( '.see-more-container' ).hide();
	});
} )( jQuery );
